/* ============================================================
   OMNIVIA WELLNESS — Theme behavior
   Vanilla JS, no dependencies. Safe inside the Shopify Theme Editor.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var moneyFormat = (window.OMNIVIA && window.OMNIVIA.moneyFormat) || '${{amount}}';
  var routes = (window.OMNIVIA && window.OMNIVIA.routes) || {};

  /* ---------- utilities ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    if (moneyFormat.indexOf('amount_no_decimals') > -1) {
      amount = parts[0];
    }
    return moneyFormat.replace(/\{\{\s*amount[^}]*\s*\}\}/, amount);
  }

  /* ---------- 1. Scroll reveal ---------- */
  function initReveal(scope) {
    var nodes = $$('[data-reveal]', scope || document);
    if (!nodes.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---------- 2. Header ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var lastY = window.scrollY;
    var ticking = false;

    function update() {
      var y = window.scrollY;
      header.classList.toggle('om-header--solid', y > 40);
      if (y > 400 && y > lastY + 6) {
        header.classList.add('om-header--hidden');
      } else if (y < lastY - 6 || y < 200) {
        header.classList.remove('om-header--hidden');
      }
      lastY = y;
      ticking = false;
    }
    on(window, 'scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- 3. Mobile drawer ---------- */
  function initDrawer() {
    var drawer = $('[data-drawer]');
    if (!drawer) return;
    function setOpen(open) {
      drawer.setAttribute('data-open', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    }
    $$('[data-drawer-open]').forEach(function (b) { on(b, 'click', function () { setOpen(true); }); });
    $$('[data-drawer-close]').forEach(function (b) { on(b, 'click', function () { setOpen(false); }); });
    $$('a', drawer).forEach(function (a) { on(a, 'click', function () { setOpen(false); }); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  }

  /* ---------- 4. Accordions ---------- */
  function initAccordions(scope) {
    $$('[data-acc]', scope || document).forEach(function (acc) {
      if (acc.dataset.accReady === '1') return;
      acc.dataset.accReady = '1';
      var single = acc.hasAttribute('data-acc-single');
      $$('[data-acc-btn]', acc).forEach(function (btn) {
        var panel = btn.nextElementSibling;
        if (!panel) return;
        if (btn.getAttribute('aria-expanded') === 'true') {
          panel.style.height = 'auto';
        }
        on(btn, 'click', function () {
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          if (single && !isOpen) {
            $$('[data-acc-btn]', acc).forEach(function (other) {
              if (other === btn) return;
              other.setAttribute('aria-expanded', 'false');
              var op = other.nextElementSibling;
              if (op) { op.style.height = op.scrollHeight + 'px'; op.offsetHeight; op.style.height = '0px'; }
            });
          }
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (isOpen) {
            panel.style.height = panel.scrollHeight + 'px';
            panel.offsetHeight;
            panel.style.height = '0px';
          } else {
            panel.style.height = panel.scrollHeight + 'px';
            var done = function () { panel.style.height = 'auto'; panel.removeEventListener('transitionend', done); };
            panel.addEventListener('transitionend', done);
          }
        });
      });
    });
  }

  /* ---------- 5. Product gallery ---------- */
  function initGallery(scope) {
    $$('[data-gallery]', scope || document).forEach(function (gal) {
      var main = $('[data-gallery-main]', gal);
      if (!main) return;
      $$('[data-gallery-thumb]', gal).forEach(function (thumb) {
        on(thumb, 'click', function () {
          var src = thumb.getAttribute('data-src');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt') || '';
          if (src) main.src = src;
          if (srcset) main.srcset = srcset;
          main.alt = alt;
          $$('[data-gallery-thumb]', gal).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });
  }

  /* ---------- 6. Quantity steppers ---------- */
  function initQty(scope) {
    $$('[data-qty]', scope || document).forEach(function (wrap) {
      var input = $('input', wrap);
      if (!input) return;
      $$('[data-qty-step]', wrap).forEach(function (btn) {
        on(btn, 'click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 1;
          var min = parseInt(input.min, 10) || 1;
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = Math.max(min, next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- 7. Variant selection ---------- */
  function initVariants(scope) {
    $$('[data-variant-picker]', scope || document).forEach(function (picker) {
      var form = picker.closest('form');
      var data = $('[data-variant-json]', picker);
      if (!data) return;
      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }

      var idInput = form ? $('[name="id"]', form) : null;
      var priceEl = $('[data-price-current]', picker.closest('[data-product-root]') || document);
      var compareEl = $('[data-price-compare]', picker.closest('[data-product-root]') || document);
      var submit = form ? $('[data-add-btn]', form) : null;
      var submitText = submit ? $('[data-add-text]', submit) : null;

      function selectedOptions() {
        return $$('[data-option-group]', picker).map(function (group) {
          var chosen = $('[aria-checked="true"]', group);
          return chosen ? chosen.getAttribute('data-value') : null;
        });
      }

      function apply() {
        var opts = selectedOptions();
        var match = variants.find(function (v) {
          return opts.every(function (o, i) { return o === null || v.options[i] === o; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = formatMoney(match.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (submit) {
          submit.disabled = !match.available;
          if (submitText) submitText.textContent = match.available
            ? (submit.getAttribute('data-text-add') || 'Add to cart')
            : (submit.getAttribute('data-text-sold') || 'Sold out');
        }
        if (history.replaceState && match.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      }

      $$('[data-option-group]', picker).forEach(function (group) {
        $$('[data-value]', group).forEach(function (btn) {
          on(btn, 'click', function () {
            $$('[data-value]', group).forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
            btn.setAttribute('aria-checked', 'true');
            apply();
          });
        });
      });
      apply();
    });
  }

  /* ---------- 8. Selling plans ---------- */
  function initPlans(scope) {
    $$('[data-plan-group]', scope || document).forEach(function (group) {
      var form = group.closest('form');
      var input = form ? $('[name="selling_plan"]', form) : null;
      $$('[data-plan-opt]', group).forEach(function (opt) {
        on(opt, 'click', function () {
          $$('[data-plan-opt]', group).forEach(function (o) { o.setAttribute('data-selected', 'false'); });
          opt.setAttribute('data-selected', 'true');
          if (input) input.value = opt.getAttribute('data-plan-id') || '';
        });
      });
    });
  }

  /* ---------- 9. Cart count refresh ---------- */
  function refreshCartCount() {
    if (!routes.cart_url) return;
    fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ---------- 10. Async add to cart ---------- */
  function initAddToCart(scope) {
    $$('[data-product-form]', scope || document).forEach(function (form) {
      on(form, 'submit', function (e) {
        if (!routes.cart_add_url) return;
        e.preventDefault();
        var btn = $('[data-add-btn]', form);
        var text = btn ? $('[data-add-text]', btn) : null;
        var original = text ? text.textContent : '';
        if (btn) btn.disabled = true;
        if (text) text.textContent = 'Adding…';

        fetch(routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status && res.status !== 200) throw new Error(res.description || 'Error');
            if (text) text.textContent = 'Added';
            refreshCartCount();
            setTimeout(function () { if (text) text.textContent = original; if (btn) btn.disabled = false; }, 1600);
          })
          .catch(function () {
            if (text) text.textContent = 'Unavailable';
            setTimeout(function () { if (text) text.textContent = original; if (btn) btn.disabled = false; }, 1800);
          });
      });
    });
  }

  /* ---------- 11. Marquee duplication ---------- */
  function initMarquee(scope) {
    $$('[data-marquee]', scope || document).forEach(function (track) {
      if (track.dataset.marqueeReady === '1') return;
      track.dataset.marqueeReady = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* ---------- 12. Count-up statistics ---------- */
  function initCounters(scope) {
    var nodes = $$('[data-count]', scope || document);
    if (!nodes.length || reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.textContent = n.getAttribute('data-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-count'));
        var decimals = (el.getAttribute('data-count').split('.')[1] || '').length;
        var start = null;
        var dur = 1500;
        function tick(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(decimals);
          if (p < 1) requestAnimationFrame(tick);
          else el.textContent = target.toFixed(decimals);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---------- boot ---------- */
  function boot(scope) {
    initReveal(scope);
    initAccordions(scope);
    initGallery(scope);
    initQty(scope);
    initVariants(scope);
    initPlans(scope);
    initAddToCart(scope);
    initMarquee(scope);
    initCounters(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); initHeader(); initDrawer(); });
  } else {
    boot(); initHeader(); initDrawer();
  }

  /* Theme Editor lifecycle — re-init when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target); });

  window.OMNIVIA = window.OMNIVIA || {};
  window.OMNIVIA.boot = boot;
  window.OMNIVIA.formatMoney = formatMoney;
})();
